import { peekPersistentItem } from '../vrs-auth/storage';
const ACTIVE_CALL_KEY = 'vrs_active_call';
let last;
/**
 * The stored call (`vrs_active_call`) for the call layouts' partner pane,
 * read the way a mapStateToProps must: without writing anything back, and
 * parsed only when the stored text changes.
 *
 * Both VRSLayouts compute their props on every store update.
 * getPersistentJson would re-mirror the value into sessionStorage and queue
 * an AsyncStorage write on every one of them (vrs-auth/storage.ts). The text
 * is still read each time, because the room itself may rewrite the record
 * (vrs-room-controls.js keeps it current, e.g. with a new interpreter name).
 */
export function readStoredActiveCall() {
    const raw = peekPersistentItem(ACTIVE_CALL_KEY);
    if (last && last.raw === raw) {
        return last.value;
    }
    let value = null;
    if (raw) {
        try {
            const parsed = JSON.parse(raw);
            value = parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
        }
        catch {
            value = null;
        }
    }
    last = { raw, value };
    return value;
}
